<template>
  <div class="record-box" v-if="recordType === 'trade'">
    <div class="record-title">
      <div class="record-name">
        第{{ record.planWeek }}周打卡
        <span class="record-time">
          {{ record.planWeekStartDate | parseTime("{m}-{d}", true) }}-
          {{ record.planWeekEndDate | parseTime("{m}-{d}", true) }}
        </span>
      </div>
      <div class="record-status">{{ record.planWeekStatusName }}</div>
    </div>

    <div class="record-list steps-row">
      <div v-for="(item, index) in record.weekStatusList" :key="index" class="step-pointer">
        <div class="step-name">{{ item.createUserName || "" }}</div>
        <div class="step-status step-status-stack">
          <div>{{ item.planWeekStatusName || "" }}</div>
          <div class="step-status-time" v-if="item.createDate">
            {{ item.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
          </div>
        </div>
      </div>
    </div>

    <div class="record-img" v-if="record.stackImgList.length" v-viewer="{movable: true}">
      <div class="record-img-item" v-for="img in record.stackImgList" :key="img.imgUrl">
        <img :src="img.imgUrl">
        <div class="record-img-status">{{ getCheckResult(img.imgStatus) }}</div>
      </div>
    </div>
  </div>

  <div class="record-box" v-else>
    <div class="record-title">
      <div class="record-name">
        第{{ record.planWeek }}周打卡
        <span class="record-time">
          {{ record.trackStartDate | parseTime("{m}-{d}", true) }}-
          {{ record.trackEndDate | parseTime("{m}-{d}", true) }}
        </span>
      </div>
      <div class="record-status">{{ record.trackStatusName }}</div>
    </div>

    <div class="record-list steps-row">
      <div v-for="(item, index) in record.weekStatusList" :key="index" class="step-pointer">
        <div class="step-name">{{ item.createUserName || "" }}</div>
        <div class="step-status step-status-stack">
          <div>{{ item.planWeekStatusName || "" }}</div>
          <div class="step-status-time" v-if="item.createDate">
            {{ item.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
          </div>
        </div>
      </div>
    </div>

    <div class="record-img" v-if="record.tradePerfectTrackTaskList.length" v-viewer="{movable: true}">
      <div class="record-img-item" v-for="img in trackTaskListHasImg" :key="img.checkPhotoUri">
        <img :src="getImg(img.checkPhotoUri)">
        <div class="record-img-status">{{ getCheckResult(img.imgStatus) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  name: 'stack-record-item',
  props: {
    record: {
      type: Object,
      default: () => {}
    },
    recordType: {
      type: String,
      default: ''
    }
  },
  computed: {
    trackTaskListHasImg () {
      return this.record.tradePerfectTrackTaskList.filter(task => {
        return task.checkPhotoUri
      })
    }
  },
  methods: {
    getCheckResult (result) {
      if (result === 0) return '未通过'
      if (result === 1) return '通过'
      if (result === -1) return '结果暂未返回'
      if (result === -2) return '待人工审核'
      return '暂无'
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
.record-box {
  width: 100%;
  background-color: #fff;
  margin-top: 15px;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 15px;

  .record-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;

    .record-time {
      font-weight: normal;
      color: #666;
      font-size: 13px;
      padding-left: 15px;
    }

    .record-status {
      color: $base-red;
    }
  }

  .steps-row {
    margin-top: 15px;
    position: relative;
    counter-reset: step;
    // display: flex;
    width: 100%;
    .step-pointer {
      text-align: center;
      position: relative;
      z-index: 10;
      width: 100%;
      height: 40px;
      line-height: 20px;
      & > div {
        position: absolute;
        top: 0;
        font-size: 14px;
        color: #333;
      }
      .step-name {
        width: 17%;
        text-align: right;
        left: 25%;
      }
      .step-status {
        left: calc(50% + 40px);
        div {
          text-align: left;
        }
        .step-status-time {
          font-size: 12px;
          margin-top: -3px;
          color: #999;
        }
      }
      .step-status-stack {
        line-height: 20px;
      }

      &:before {
        display: block;
        content: counter(step);
        counter-increment: step;
        width: 20px;
        height: 20px;
        background-color: $base-red;
        line-height: 20px;
        border-radius: 20px;
        font-size: 13px;
        color: $base-red;
        text-align: center;
        font-weight: normal;
        margin: 0 auto 0 auto;
      }
    }

    .step-pointer ~ .step-pointer:after {
      content: "";
      width: 4px;
      height: 22px;
      background-color: $base-red;
      position: absolute;
      left: calc(50% - 2px);
      top: -20px;
      z-index: 1;
    }
  }

  .step-pointer.actived:before,
  .step-pointer.actived:after {
    background-color: $base-red;
    color: $base-red;
  }

  .step-pointer.actived ~ .step-pointer:before,
  .step-pointer.actived ~ .step-pointer:after {
    background-color: #aaa;
    color: #aaa;
  }
}

.record-img {
  display: flex;
  margin-top: 12px;
  width: 100%;
  padding-bottom: 10px;
  overflow-x: auto;

  .record-img-item {
    width: 28%;
    flex-shrink: 0;
    height: 110px;
    margin: 0 3.16%;
    img {
      width: 100%;
      height: calc(100% - 20px);
      border-radius: 5px;
      object-fit: cover;
      cursor: pointer;
    }

    .record-img-status {
      font-size: 14px;
      color: #666;
      text-align: center;
      margin-top: 5px;
    }
  }
}
</style>
